import appStore from 'store';
import api from './api';

const store = {

    namespaced : true,

    state : {
        adminUserList : []
    },

    mutations : {
        setAdminUserList(state,payload) {
            state.adminUserList = payload;
        }
    },

    actions: {
        getAdminUserList({ commit}) {
            api.getUserInfoList().then( response => {
                commit('setAdminUserList',response.data);
            })
        },

        alterUserAuthType({ commit },data) {
            return api.alertUserAuthInfo(data);
        }
    }
};

appStore.registerModule('userAuth',store);